import type { TipoEnlacesInteresModel, StrapiResponseModel } from '@/interfaces/model';
import type { TipoEnlaceInteres, StrapiListResponse } from '@/interfaces/strapi';

export const enlaceInteresMapper = (c: TipoEnlacesInteresModel): TipoEnlaceInteres => ({
	name: c.name,
	enlaces: c.enlaces,
});

export const enlacesInteresListMapper = (
	res: StrapiResponseModel<TipoEnlacesInteresModel>,
): StrapiListResponse<TipoEnlaceInteres> => {
	const list = (res.data ?? []).map(enlaceInteresMapper);

	const pagination = res.meta?.pagination ?? {
		page: 1,
		pageSize: list.length,
		pageCount: 1,
		total: list.length,
	};

	return { list, pagination };
};
